export const DAILY_CASE_CAP = 2000;
export const BOTTLE_TYPES = ["Burgundy", "Bordeaux", "Sparkling", "Hock"];
export const BOTTLE_FORMATS = ["375ml", "750ml", "1.5L", "3L"];
export const FILTER_TYPES = ["10µ/BC", "Sterile"];

export const WINE_GATE_ORDER = [
  "sparkling", "champagne", "prosecco", "cava",
  "sauvignon blanc", "pinot grigio", "pinot gris", "riesling", "gewurztraminer",
  "chardonnay", "roussanne", "marsanne", "viognier", "white blend",
  "rosé", "rose", "vin gris",
  "pinot noir",
  "grenache", "syrah", "merlot", "sangiovese", "tempranillo",
  "malbec", "cabernet franc", "cabernet sauvignon", "petite sirah", "zinfandel",
  "red blend", "port", "dessert",
];

export type BottlingEventStatus = "draft" | "submitted" | "confirmed" | "locked" | "completed";

export interface BottlingSku {
  id?: string;
  brand: string;
  wine: string;
  vintage: string;
  bottle: string;
  format: string;
  closure: string;
  label: string;
  capsule: string;
  casePack: number;
  cases: number;
  filter: string;
  dmdc: string;
  fanciful: string;
  ava: string;
  lotCode: string;
  instructions: string;
  caseStickers?: boolean;
}

export const BLANK_SKU: BottlingSku = {
  brand: "", wine: "", vintage: "", bottle: "", format: "750ml",
  closure: "", label: "Yes", capsule: "No", casePack: 12, cases: 0,
  filter: "", dmdc: "No", fanciful: "", ava: "", lotCode: "", instructions: "", caseStickers: false,
};

export const PAGE_SIZE = 15;

export function calcGallons(cases: number, casePack: number, format: string): number {
  const liters = format === "375ml" ? 0.375 : format === "1.5L" ? 1.5 : format === "3L" ? 3 : 0.75;
  return Math.round((cases || 0) * (casePack || 12) * liters * 0.264172);
}

export function calcLockDate(confirmedDate: string): string | null {
  if (!confirmedDate) return null;
  const d = new Date(confirmedDate + "T12:00:00");
  d.setDate(d.getDate() - 7);
  return d.toISOString().split("T")[0];
}

export function fmtDate(dateStr: string | null | undefined, opts: Intl.DateTimeFormatOptions = { month: "long", day: "numeric", year: "numeric" }): string {
  if (!dateStr) return "—";
  return new Date(dateStr + "T12:00:00").toLocaleDateString("en-US", opts);
}

export function fmtDateShort(dateStr: string | null | undefined): string {
  return fmtDate(dateStr, { month: "short", day: "numeric", year: "numeric" });
}
